import React from "react";

const WorkflowPage = () => {
  return <div>WorkflowPage</div>;
};

export default WorkflowPage;
